<script setup>
import AppLogin1 from "@/components/Common/TheLoginEmail";
import AppLogin2 from "@/components/Common/TheLoginNumber";
import AppRegister from "@/components/Common/TheRegister";
import AppRecovery from "@/components/Common/TheRecovery";
import AppWhatNew from "@/components/Common/TheWhatNew";
import {ref,computed} from 'vue'

//----------------------------------------------------------------------
//const route = useRoute()
const isTab1 = ref(true)
const isTab2 = ref(false)
//----------------------------------------------------------------------
const setTab = (index) => {
  if (index === 1){
    isTab1.value = true
    isTab2.value = false
  } else {
    isTab2.value = true
    isTab1.value = false
  }
}
//----------------------------------------------------------------------
const activeComponent = computed( () => {
  return isTab1.value === true;
})
//----------------------------------------------------------------------
const isModalVisible = ref(false)
const isModalRecoveryVisible = ref(false)
const isModalWhatNew = ref(false)

const successRegister = () => {
  isModalVisible.value = false
}

const successRecovery = () => {
  isModalRecoveryVisible.value = false
}

</script>
<template>
  <div class="card">
    <div class="card-header text-center">
      <img src="https://gorcenter.spb.ru/images/logo.png" class="mb-3">
      <h3>Личный кабинет</h3><p>клиента СПБ ЦДЖ</p>
    </div>
    <div class="card-body">

      <div class="d-flex justify-content-between mb-4">
        <div
            :class="['login-type', {'login-type-active': isTab1}]"
            @click="setTab(1)"
        >E-mail</div>
        <div
            :class="['login-type', {'login-type-active': isTab2}]"
            @click="setTab(2)"
        >Идентификатор договора</div>
      </div>

      <keep-alive>
          <component :is="activeComponent ? AppLogin1 : AppLogin2"></component>
      </keep-alive>

      <button
          class="btn btn-danger btn-block mt-3"
          @click="isModalVisible = true"
      >Зарегистрироваться</button>

      <div class="text-center mt-4">
        Для восстановления доступа в личный кабинет обращайтесь по тел.:
        <h4>(812) 331-57-37  доб. 3</h4>
      </div>

      <div class="text-right mt-3 mr-1 ml-1 d-none">
        <a href @click.prevent="isModalWhatNew = true" >Что нового?</a>
      </div>

    </div>
  </div>

  <teleport to="body">
    <v-modal
        v-if="isModalVisible"
        title="Регистрация в личном кабинете"
        modalType="modal-dialog-scrollable modal-lg"
        @close="isModalVisible = false"
    >
      <AppRegister @success="successRegister"></AppRegister>
    </v-modal>

    <v-modal
        v-if="isModalRecoveryVisible"
        title="Восстановление доступа в личный кабинет"
        modalType="modal-dialog-scrollable modal-lg"
        @close="isModalRecoveryVisible = false"
    >
      <AppRecovery @success="successRecovery"></AppRecovery>
    </v-modal>

    <v-modal
        v-if="isModalWhatNew"
        title="Что нового"
        modalType="modal-dialog-scrollable modal-lg"
        @close="isModalWhatNew = false"
    >
      <AppWhatNew></AppWhatNew>
    </v-modal>

  </teleport>

</template>
<style scoped>
  .login-type {
    padding:8px 12px;
    cursor:pointer;
    border-radius: 5px;
    border: 1px solid #54a5d3;
    background-color: #e0eaf6;
  }
  .login-type-active {
    background-color: #54a5d3;
    color:#fff;
  }
</style>